import React from "react";
import Table from "../../Common/Table";

import Permission from "../../Common/Permission";
import TableFields from "../../../constants/Feature/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { Pill } from "../../../constants/assets/containers";

const FeatureList = ({ handleClick, featureList }) => {
  const allActions = MenuActionsMappings[MenuNames.FEATURE];

  const getFeatureStatus = (val) => {
    switch (val) {
      case 0:
        return "Disabled";
      case 1:
        return "Enabled";
      case 2:
        return "Killed";
      case 3:
        return "Stable";
      default:
        return "Disabled";
    }
  };

  const getFieldValue = (feature, key) => {
    switch (key) {
      case "status":
        if (feature["isDeleted"]) {
          return <Pill isFalse={true}>Deleted</Pill>;
        }
        return (
          <Pill isFalse={!feature[key]}>{getFeatureStatus(feature[key])}</Pill>
        );
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", feature.id)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      default:
        return getPath(feature, key, "NA");
    }
  };

  return (
    <Permission requiredPerms={[allActions.LIST]}>
      <Table
        list={featureList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default FeatureList;
